"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = ModalHeader;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../constants/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ModalHeader(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "modal__header"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", null, props.children),
    /*#__PURE__*/
    _react["default"].createElement("button", {
      onClick: props.onDismiss,
      className: "modal__header-dismiss-button",
      type: "button"
    },
    /*#__PURE__*/
    _react["default"].createElement("span", {
      className: _icons.icons.close
    })))
  );
}

ModalHeader.propTypes = {
  children: _propTypes["default"].node.isRequired,
  onDismiss: _propTypes["default"].func.isRequired
};